var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoundedTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    preserveAspectRatio: "none",
    viewBox: "0 0 360 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rounded-top_svg__clip0_1337_13719)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#rounded-top_svg__filter0_f_1337_13719)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.002h360V2C222.691 13.97 143.338 14.037 0 2v10.002z",
    fill: "#131A2D",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.005h360V3.002c-137.309 11.969-216.662 12.038-360 0v10.003z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rounded-top_svg__clip0_1337_13719"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h360v13H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rounded-top_svg__filter0_f_1337_13719",
    x: -2,
    y: 0,
    width: 364,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1337_13719"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iY3VycmVudCIgaGVpZ2h0PSJjdXJyZW50IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDAgMzYwIDEzIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTMzN18xMzcxOSkiPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9mXzEzMzdfMTM3MTkpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjAwNDA3ZS0wNSAxMi4wMDIyTDM2MCAxMi4wMDIzVjIuMDAwMDZDMjIyLjY5MSAxMy45Njg1IDE0My4zMzggMTQuMDM3NSAwIDJMMy4wMDQwN2UtMDUgMTIuMDAyMloiIGZpbGw9IiMxMzFBMkQiIGZpbGwtb3BhY2l0eT0iMC4xNSIvPgo8L2c+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy4wMDQwN2UtMDUgMTMuMDA0NkwzNjAgMTMuMDA0N1YzLjAwMjVDMjIyLjY5MSAxNC45NzA5IDE0My4zMzggMTUuMDM5OSAwIDMuMDAyNDRMMy4wMDQwN2UtMDUgMTMuMDA0NloiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZl8xMzM3XzEzNzE5IiB4PSItMiIgeT0iMCIgd2lkdGg9IjM2NCIgaGVpZ2h0PSIxMyIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxIiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXJfMTMzN18xMzcxOSIvPgo8L2ZpbHRlcj4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMzM3XzEzNzE5Ij4KPHJlY3Qgd2lkdGg9IjM2MCIgaGVpZ2h0PSIxMyIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=";
export { SvgRoundedTop as ReactComponent };